module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-03.abae2389.png";